import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import OurSolution from "../Solution/OurSolutions";
import AboutSulution from "../Solution/AboutSulution";
const Solution = () => {
  return (
    <div>
      <Header />
      <AboutSulution />
      <OurSolution />
      <Footer />
    </div>
  );
};

export default Solution;
